import script from "./term.vue?vue&type=script&setup=true&lang=ts"
export * from "./term.vue?vue&type=script&setup=true&lang=ts"

import "./term.vue?vue&type=style&index=0&id=1f8bf9a4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f8bf9a4"]])

export default __exports__